// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.open-sidebar {
  display: flex;
  position: fixed;
  background-color: rgba(142, 198, 63, 0.952);
  height: 100vh;
  width: 50vw;
  top: 0;
  left: 0;
  z-index: 2000;
  background: rgba(142, 198, 63, 0.25);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);
}
.open-sidebar .sidebar-body {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px;
  gap: 30px;
  overflow-y: auto;
}
.open-sidebar .sidebar-body::-webkit-scrollbar {
  display: none;
}
.open-sidebar .sidebar-button {
  height: 100%;
}
.open-sidebar .sidebar-button .button-label {
  font-size: 32px;
  animation: bounce 3s infinite;
}
.open-sidebar .sidebar-button button {
  margin: 0;
  height: 100%;
  position: absolute;
  left: calc(50vw - 5px);
  top: 0;
  font-size: 24px;
}

.closed-sidebar {
  height: 100%;
  position: fixed;
  z-index: 1001;
}
.closed-sidebar .sidebar-body {
  height: 100%;
  display: none;
}
.closed-sidebar .sidebar-button {
  height: 100%;
}
.closed-sidebar .sidebar-button button {
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  margin-top: -83px;
  font-size: 24px;
  animation: bounce 3s infinite;
}

@media screen and (max-width: 1100px) {
  html::-webkit-scrollbar {
    display: none;
  }
  .open-sidebar {
    width: 100vw;
  }
  .open-sidebar .sidebar-button {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .open-sidebar .sidebar-button button {
    width: 40px;
    height: 100%;
    position: static;
    top: 0;
    font-size: 24px;
    animation: bounce 3s infinite;
  }
}
@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px);
  }
  60% {
    transform: translateY(-15px);
  }
}
@keyframes roll {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/new-ticket-sidebar/new-ticket-sidebar.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,2CAAA;EACA,aAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EAEA,oCAAA;EACA,gDAAA;EACA,0BAAA;EACA,kCAAA;EACA,mBAAA;EACA,2CAAA;AAAF;AAEE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;EACA,gBAAA;AAAJ;AAEI;EACE,aAAA;AAAN;AAIE;EACE,YAAA;AAFJ;AAII;EACE,eAAA;EACA,6BAAA;AAFN;AAII;EACE,SAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,MAAA;EACA,eAAA;AAFN;;AAOA;EACE,YAAA;EACA,eAAA;EACA,aAAA;AAJF;AAKE;EACE,YAAA;EACA,aAAA;AAHJ;AAME;EACE,YAAA;AAJJ;AAMI;EACE,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,iBAAA;EACA,eAAA;EACA,6BAAA;AAJN;;AASA;EAEI;IACE,aAAA;EAPJ;EAUA;IACE,YAAA;EARF;EAUE;IACE,aAAA;IACA,uBAAA;IACA,mBAAA;EARJ;EASI;IACE,WAAA;IACA,YAAA;IACA,gBAAA;IACA,MAAA;IACA,eAAA;IACA,6BAAA;EAPN;AACF;AAYA;EACE;IAKE,wBAAA;EAdF;EAgBA;IACE,4BAAA;EAdF;EAgBA;IACE,4BAAA;EAdF;AACF;AAiBA;EACE;IACE,uBAAA;EAfF;EAiBA;IACE,yBAAA;EAfF;EAiBA;IACE,uBAAA;EAfF;AACF","sourcesContent":[".open-sidebar {\n  display: flex;\n  position: fixed;\n  background-color: rgba(142, 198, 63, 0.952);\n  height: 100vh;\n  width: 50vw;\n  top: 0;\n  left: 0;\n  z-index: 2000;\n\n  background: rgba(142, 198, 63, 0.25);\n  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n\n  .sidebar-body {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    padding: 20px;\n    gap: 30px;\n    overflow-y: auto;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  .sidebar-button {\n    height: 100%;\n\n    .button-label {\n      font-size: 32px;\n      animation: bounce 3s infinite;\n    }\n    button {\n      margin: 0;\n      height: 100%;\n      position: absolute;\n      left: calc(50vw - 5px);\n      top: 0;\n      font-size: 24px;\n    }\n  }\n}\n\n.closed-sidebar {\n  height: 100%;\n  position: fixed;\n  z-index: 1001;\n  .sidebar-body {\n    height: 100%;\n    display: none;\n  }\n\n  .sidebar-button {\n    height: 100%;\n\n    button {\n      height: 100%;\n      position: absolute;\n      left: 0;\n      top: 0;\n      margin-top: -83px;\n      font-size: 24px;\n      animation: bounce 3s infinite;\n    }\n  }\n}\n\n@media screen and (max-width: 1100px) {\n  html {\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n  .open-sidebar {\n    width: 100vw;\n\n    .sidebar-button {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      button {\n        width: 40px;\n        height: 100%;\n        position: static;\n        top: 0;\n        font-size: 24px;\n        animation: bounce 3s infinite;\n      }\n    }\n  }\n}\n\n@keyframes bounce {\n  0%,\n  20%,\n  50%,\n  80%,\n  100% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-30px);\n  }\n  60% {\n    transform: translateY(-15px);\n  }\n}\n\n@keyframes roll {\n  0% {\n    transform: rotate(0deg);\n  }\n  50% {\n    transform: rotate(360deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
